import { render, staticRenderFns } from "./DataAnalysisSvg.vue?vue&type=template&id=5365ecf3&"
import script from "./DataAnalysisSvg.vue?vue&type=script&lang=ts&"
export * from "./DataAnalysisSvg.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/brilliant/brilliant/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('5365ecf3', component.options)
    } else {
      api.reload('5365ecf3', component.options)
    }
    module.hot.accept("./DataAnalysisSvg.vue?vue&type=template&id=5365ecf3&", function () {
      api.rerender('5365ecf3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/views/premium/paywall/svgs/DataAnalysisSvg.vue"
export default component.exports